/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class ChattagsDialog extends NoboxEntityDialog<ChattagsRow, any> {
        protected getFormKey() { return ChattagsForm.formKey; }
        protected getIdProperty() { return ChattagsRow.idProperty; }
        protected getLocalTextPrefix() { return ChattagsRow.localTextPrefix; }
        protected getNameProperty() { return ChattagsRow.nameProperty; }
        protected getService() { return ChattagsService.baseUrl; }
        protected getDeletePermission() { return ChattagsRow.deletePermission; }
        protected getInsertPermission() { return ChattagsRow.insertPermission; }
        protected getUpdatePermission() { return ChattagsRow.updatePermission; }

        protected form = new ChattagsForm(this.idPrefix);
        public callback = (response,tag) => {

        }
        public valTag = '';
        protected save() {
            this.valTag = this.form.Nm.value;
            super.save();
        }

        protected onSaveSuccess(response) {
            this.callback(response, this.valTag);
            //sendMsg(JSON.stringify({ Type: 'NonMsg', Menu:'tags', Sender: $(".nk-chat-body").attr("data-ag-id"), IsAddTags: 'add', IsInfo: false, Entity: { Id: response.EntityId, Nm: this.valTag }, RoomId: $(".nk-chat-body").attr("data-id") }), $(".nk-chat-body").attr("data-id"));
            super.onSaveSuccess(response);

            Serenity.SubDialogHelper.triggerDataChange(this);   // *** Refreshing the parent grid ***
            this.dialogClose();    // *** Closing the dialog ***
        }
    }
}